// components/Chatbot.js
import React, { memo } from "react";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
import styled from "styled-components";  // Import styled-components
import robotIcon from "../assets/img/icons8-music-robot-94.png"; // Your custom bot avatar
import customFloatingIcon from "../assets/img/icons8-music-robot-94.png"; // Your custom floating icon

// Define the keyframes for the jump animation
const JumpingIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #007bff; /* Customize the background color */
  border-radius: 50%;
  animation: jump 1.5s infinite; /* Apply jumping animation */

  /* Add your custom icon inside */
  img {
    width: 30px;
    height: 30px;
  }

  /* Jump animation */
  @keyframes jump {
    0% {
      transform: translateY(0);
    }
    30% {
      transform: translateY(-10px);
    }
    50% {
      transform: translateY(0);
    }
    70% {
      transform: translateY(-6px);
    }
    100% {
      transform: translateY(0);
    }
  }
`;

// Define chatbot steps
const steps = [
  { id: "1", message: "Hi, I'm Amectar Bot! How can I assist you today?", trigger: "2" },
  {
    id: "2",
    options: [
      { value: "services", label: "Tell me about your services", trigger: "services" },
      { value: "question", label: "I have a question", trigger: "question" },
      { value: "contact", label: "How can I contact you?", trigger: "contact" },
    ],
  },
  { id: "services", message: "We offer web design, development, and SEO services.", trigger: "moreHelp" },
  {
    id: "contact",
    message: "You can reach us at ",
    trigger: "email",
  },
  {
    id: "email",
    component: (
      <a href="mailto:amanmanthiraamex@gmail.com">amanmanthiraamex@gmail.com</a>
    ),
    asMessage: true,
    trigger: "moreHelp",
  },
  {
    id: "question",
    message: "Please type your question below, and I'll do my best to help!",
    trigger: "userInput",
  },
  {
    id: "userInput",
    user: true,
    trigger: "analyzeQuestion",
  },
  {
    id: "analyzeQuestion",
    message: ({ previousValue }) => {
      const userQuestion = previousValue.toLowerCase();
      if (userQuestion.includes("price") || userQuestion.includes("cost")) {
        return "Our pricing depends on the project. Contact us for a quote!";
      } else if (userQuestion.includes("support")) {
        return "We offer 24/7 customer support. How can we assist you further?";
      } else {
        return "I'm here to help, but I may need more information. Please reach out directly if needed!";
      }
    },
    trigger: "moreHelp",
  },
  {
    id: "moreHelp",
    message: "Is there anything else I can help you with?",
    trigger: "2",
  },
];

// Chatbot theme
const theme = {
  background: "#f5f8fb",
  fontFamily: "Arial, Helvetica, sans-serif",
  headerBgColor: "#007bff",
  headerFontColor: "#fff",
  headerFontSize: "16px",
  botBubbleColor: "#007bff",
  botFontColor: "#fff",
  userBubbleColor: "#fff",
  userFontColor: "#4a4a4a",
};

// Chatbot component
const Chatbot = () => (
  <ThemeProvider theme={theme}>
    <ChatBot
      steps={steps}
      floating
      headerTitle="Amectar Bot"
      botAvatar={robotIcon}
      floatingIcon={<JumpingIcon><img src={customFloatingIcon} alt="Chatbot Icon" /></JumpingIcon>} 
    />
  </ThemeProvider>
);

export default memo(Chatbot);
